import { useContext } from 'react';
import { AuthContext } from '../Context/AuthContext';
import { useMutation } from '@tanstack/react-query';
import { exchangeToken } from '../Service/AuthApi';



export function useIsAuthenticated(): boolean {
    const context = useContext(AuthContext);
    if (!context) {
        throw new Error('useAuth must be used within an AuthProvider');
    }
    return context.isAuthenticated;
};

export function useLogout() {
    const context = useContext(AuthContext);
    if (!context) {
        throw new Error('useAuth must be used within an AuthProvider');
    }
    return () => {
        context.setToken();
    }
}

export function useTokenExchange(onSuccess: () => void) {
    const context = useContext(AuthContext);
    if (!context) {
        throw new Error('useAuth must be used within an AuthProvider');
    }
    return useMutation(
        {
            mutationFn: exchangeToken,
            onSuccess: (data) => {
                context.setToken(data.token);
                onSuccess();
            }
        }
    );
}